export const drugsAddDialog_style = {
  titleSx: {
    fontSize: 16,
    fontWeight: 600,
  },
  dialogSx: {
    width: '650px',
  },
};
